module.exports = __webpack_public_path__ + "static/media/autochilango-vest.48e7d1d7.svg";